<template>

  <div id="app" :src="img">
    
      <topNav></topNav>
    
    <div id="left_common">
      <leftNav></leftNav>
    </div>

    <div id="common" :style="'height:'+ (innerHeight-60)+'px;'">
        <router-view></router-view>
    </div>


  </div>
</template>

<script>
import leftNav from "./components/leftNav.vue"
import topNav from "./components/topLogo.vue"
import Home from "./components/Home.vue"
export default {
    name: 'app',
    data:function () {
      return {
          img: 'assets/adminBg.jpg',
          innerHeight:"",
      }
    },
    mounted(){
      this.innerHeight = window.innerHeight;
    },
    components:{
                leftNav,
                topNav,
                Home
                },
    methods:{

    }
}
</script>

<style>
  html,body,#app{
    height: 100%;
    background: url(assets/adminBg.jpg) no-repeat; 
    background-size: 100% 100%;
  }
body{
  margin: 0;
  padding: 0;
}
ul{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
a{
  text-decoration: none;
  color: white;
  position: relative;
}
.router-link-active {
    text-decoration: none;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* background: url(assets/adminBg.jpg) no-repeat;
    background-size: 180%; */
    margin: 0;
    padding: 0;
    overflow: hidden;

  }

#left_common{
    width: 8.5%;
    height: 90%;
    border: 1px solid #999999 ;
    float: left;
    box-sizing: border-box;
    margin-left: 0.5%;
    border-radius: 4px;

}
#common{
    height: 90%;
    width: 89%;
    margin-left: 1%;
    float: left;
    overflow-y: hidden;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue